import { saveAs } from "file-saver";
import { v4 as uuid } from "uuid";

export const downloadFile = (
  url: string,
  extension: string,
  filename?: string,
  onSuccess?: () => void,
  onFailure?: () => void
) => {
  const xhr = new XMLHttpRequest();

  xhr.open("GET", url);
  xhr.responseType = "blob";
  xhr.onload = () => {
    if (xhr?.status === 200 && xhr?.response) {
      const blob = xhr.response;

      saveAs(blob, `${filename || uuid()}.${extension}`);
      onSuccess?.();
    }
  };
  xhr.onerror = () => {
    onFailure?.();
  };
  xhr.send();
};
